/** User-facing copy for portfolio sidebar / profile sections. */

export const PORTFOLIO_SAVE_SUCCESS = 'Your changes have been saved.';

export const PORTFOLIO_SAVE_FAILED = 'We could not save your changes. Please try again.';

export const REFERENCE_AWAITING_VERIFICATION =
  'Your reference still needs to confirm via email. Check their inbox for the secure verification link.';

export const REFERENCE_HELPER_TEXT =
  'References are verified separately. We email each reference a secure link to confirm and submit short feedback on your profile.';

export const WORK_CULTURE_EMPTY_HELPER =
  'Choose up to three options that describe the work environment you thrive in.';

export function stringArraysEqual(left: string[], right: string[]): boolean {
  if (left.length !== right.length) {
    return false;
  }
  return left.every((value, index) => value === right[index]);
}

export function languagesEqual(
  left: Array<{ language?: string; level?: string }>,
  right: Array<{ language?: string; level?: string }>
): boolean {
  if (left.length !== right.length) {
    return false;
  }
  return left.every(
    (item, index) => item.language === right[index]?.language && item.level === right[index]?.level
  );
}
